import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { RTL } from 'Theme';
import { store } from 'Store';
import { Provider } from 'react-redux';
import { ThemeV2_0 } from 'ThemeV2.0';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'B2C';

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <StyledEngineProvider injectFirst>
        <RTL>
          <ThemeProvider theme={ThemeV2_0}>
            <CssBaseline />
            <Provider store={store}>
              <App msalInstance={msalInstance} />
            </Provider>
          </ThemeProvider>
        </RTL>
      </StyledEngineProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
